import * as React from 'react';
import { StyleSheet } from 'aphrodite';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

function mergeTheme(source, target) {
  const result = _extends({}, source, target);
  const objectKeys = Object.keys(result);
  for (const key of objectKeys) {
    const sourceValue = source[key];
    const targetValue = target[key];
    result[key] = typeof targetValue === "object" && typeof sourceValue === "object" ? mergeTheme(sourceValue, targetValue) : result[key];
  }
  return result;
}

function createThemeContext(theme) {
  return React.createContext(theme);
}

const ThemeSwitcherContext = React.createContext("default");

function useScopedTheme(themeContext) {
  var _React$useContext;
  const theme = React.useContext(themeContext);
  const themeName = (_React$useContext = React.useContext(ThemeSwitcherContext)) != null ? _React$useContext : "default";
  return {
    theme,
    themeName
  };
}

function withScopedTheme(styleSheet, themeContext) {
  return WrappedComponent => props => {
    const {
      theme
    } = useScopedTheme(themeContext);
    const wbThemeStyles = styleSheet(theme);
    return React.createElement(WrappedComponent, _extends({}, props, {
      wbThemeStyles: wbThemeStyles
    }));
  };
}

function useStyles(styles, theme) {
  const styleSheet = React.useMemo(() => {
    return StyleSheet.create(styles(theme));
  }, [styles, theme]);
  return styleSheet;
}

const THEME_DATA_ATTRIBUTE = "data-wb-theme";

function ThemeSwitcher({
  theme,
  children
}) {
  if (!theme) {
    return children;
  }
  const props = {
    [THEME_DATA_ATTRIBUTE]: theme
  };
  return React.createElement("div", props, children);
}

export { THEME_DATA_ATTRIBUTE, ThemeSwitcher, ThemeSwitcherContext, createThemeContext, mergeTheme, useScopedTheme, useStyles, withScopedTheme };
